import { absolutePath } from "./absolutePath";

export const planFeatureFlags = {
  show: () => absolutePath("plan_feature_flags"),
};
